import { LiveEventTagGroup } from '../../features/live-events/types/LiveEventTagGroup'
import { TrackingEventTimelineItem } from '../../features/live-events/types/LiveEvents'
import { TrackingEvent } from '../../features/live-events/types/TrackingEvents'

export enum LiveEventStripCategory {
  NewEvent = 'newEvent',
  MechanicChange = 'mechanicChange',
  OverarchingTheme = 'overarchingTheme',
}

export type NewEventStripItem = TrackingEventTimelineItem & { categories: LiveEventStripCategory[] }

// Colours match the system: Overarching = purple (calendar), Mechanic = blue (mechanic icon), New = green.
export type StripCategoryColor = 'primary' | 'success' | 'info'
export const STRIP_CATEGORY_COLOR: Record<LiveEventStripCategory, StripCategoryColor> = {
  [LiveEventStripCategory.NewEvent]: 'success',
  [LiveEventStripCategory.MechanicChange]: 'info',
  [LiveEventStripCategory.OverarchingTheme]: 'primary',
}

export const STRIP_CATEGORY_LABEL_KEY: Record<LiveEventStripCategory, string> = {
  [LiveEventStripCategory.NewEvent]: 'live-events:new_events_strip_category_new_event',
  [LiveEventStripCategory.MechanicChange]: 'live-events:new_events_strip_category_mechanic_change',
  [LiveEventStripCategory.OverarchingTheme]: 'live-events:new_events_strip_category_overarching_theme',
}

export const STRIP_CATEGORY_DESCRIPTION_KEY: Record<LiveEventStripCategory, string> = {
  [LiveEventStripCategory.NewEvent]: 'live-events:new_events_strip_category_new_event_desc',
  [LiveEventStripCategory.MechanicChange]: 'live-events:new_events_strip_category_mechanic_change_desc',
  [LiveEventStripCategory.OverarchingTheme]: 'live-events:new_events_strip_category_overarching_theme_desc',
}

export const STRIP_CATEGORY_ORDER: LiveEventStripCategory[] = [
  LiveEventStripCategory.NewEvent,
  LiveEventStripCategory.MechanicChange,
  LiveEventStripCategory.OverarchingTheme,
]

export const DEFAULT_ACTIVE_STRIP_CATEGORIES: LiveEventStripCategory[] = [LiveEventStripCategory.NewEvent]
// When a bucket mixes categories, the marker takes the most significant one's colour.
export const STRIP_CATEGORY_PRIORITY: LiveEventStripCategory[] = [
  LiveEventStripCategory.OverarchingTheme,
  LiveEventStripCategory.MechanicChange,
  LiveEventStripCategory.NewEvent,
]

// Overarching Theme is keyed off the tag group (like the rest of the app) and is exclusive; New / Mechanic derive from flags and may overlap.
export const getEventCategories = (event: TrackingEvent, tagGroupId?: string): LiveEventStripCategory[] => {
  if (tagGroupId === LiveEventTagGroup.DEFINING_OCCURRENCES) {
    return [LiveEventStripCategory.OverarchingTheme]
  }

  const categories: LiveEventStripCategory[] = []
  if (event.highlighted && event.firstInstance) categories.push(LiveEventStripCategory.NewEvent)
  if (event.firstInstance && event.mechanicChange) categories.push(LiveEventStripCategory.MechanicChange)
  return categories
}

export const getPrimaryCategory = (categories: LiveEventStripCategory[]): LiveEventStripCategory | undefined =>
  STRIP_CATEGORY_PRIORITY.find((category) => categories.includes(category))
